import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAPI } from '../utils/api';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        await analyticsAPI.trackEvent({
          event_type: 'page_view',
          page_url: location.pathname,
          user_agent: navigator.userAgent,
          referrer: document.referrer,
          utm_source: urlParams.get('utm_source') || '',
          utm_medium: urlParams.get('utm_medium') || '',
          utm_campaign: urlParams.get('utm_campaign') || ''
        });
      } catch (error) {
        console.error('Analytics tracking error:', error);
      }
    };

    trackPageView();
  }, [location]);

  return null;
};

export default AnalyticsTracker;

// Helper function to track bot clicks
export const trackBotClick = async (botType) => {
  try {
    await analyticsAPI.trackEvent({
      event_type: `${botType}_click`,
      page_url: window.location.pathname,
      user_agent: navigator.userAgent,
      referrer: document.referrer
    });
  } catch (error) {
    console.error('Bot click tracking error:', error);
  }
};